import { firestoreDateParser } from '@pedix-workspace/utils';
import { InventoryCountCatalogSnapshot } from './stock.types';
import { withNestedConverter } from '@pedix-workspace/shared-models';

export const getInventoryCountSnapshotConverter = withNestedConverter<InventoryCountCatalogSnapshot>({
  fromFirestore(snapshot) {
    const catalogSnapshot = <InventoryCountCatalogSnapshot>snapshot.data();

    return <InventoryCountCatalogSnapshot>{
      ...catalogSnapshot,
      id: snapshot.id,
      created: firestoreDateParser(catalogSnapshot.created),
    };
  },
  toFirestore(catalogSnapshot: InventoryCountCatalogSnapshot): InventoryCountCatalogSnapshot {
    return catalogSnapshot;
  },
});
